import { useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { fetchUserSuccess } from 'store/actions/account';
import API from 'util/API';

export default function useLogout() {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const history = useHistory();

  return async () => {
    try {
      await API.post('/logout');
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      history.push('/sign-in');
      dispatch(fetchUserSuccess(null));
      // Removing queries also cancels in-flight requests, so a late response
      // cannot restore this session's tickets after logout.
      queryClient.removeQueries({ queryKey: ['kitchenStatus'] });
    }
  };
}
